// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 629 ? "npm.react-app-polyfill" : chunkId) + "." + {"414":"5a538ce3","629":"f0d998c6"}[chunkId] + ".chunk.js";
};